import type { Citation, CitationSourceType } from '../lib/types';

const TYPE_LABELS: Record<CitationSourceType, { short: string; color: string }> = {
  ontology_rule: { short: 'Ontologie', color: 'bg-gold/15 border-gold/40 text-ink' },
  code_article: { short: 'Code', color: 'bg-purple-50 border-purple-200 text-purple-900' },
  rne: { short: 'RNE', color: 'bg-blue-50 border-blue-200 text-blue-900' },
  invoice_ttn: { short: 'TTN', color: 'bg-emerald-50 border-emerald-200 text-emerald-900' },
  bank_statement: { short: 'Banque', color: 'bg-cyan-50 border-cyan-200 text-cyan-900' },
  sce_entry: { short: 'Écriture', color: 'bg-amber-50 border-amber-200 text-amber-900' },
  jort: { short: 'JORT', color: 'bg-rose-50 border-rose-200 text-rose-900' },
  agent_output: { short: 'Cabinet', color: 'bg-indigo-50 border-indigo-200 text-indigo-900' },
  manual: { short: 'Manuel', color: 'bg-zinc-100 border-zinc-300 text-zinc-700' },
};

export function CitationBadge({ citation }: { citation: Citation }) {
  const meta = TYPE_LABELS[citation.source_type] ?? TYPE_LABELS.manual;
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded border ${meta.color}`}
      title={citation.reference}
    >
      <span className="font-semibold uppercase tracking-wide opacity-70">{meta.short}</span>
      <span className="font-mono text-[11px] opacity-80">{citation.source_id}</span>
    </span>
  );
}

export function CitationsPanel({ citations }: { citations: Citation[] }) {
  if (citations.length === 0) {
    return (
      <div className="text-xs text-taupe italic">
        Aucune citation produite.
      </div>
    );
  }
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {citations.map((c, i) => (
          <CitationBadge key={`${c.source_type}-${c.source_id}-${i}`} citation={c} />
        ))}
      </div>
      <details className="text-xs text-taupe">
        <summary className="cursor-pointer hover:text-ink">Détail des citations ({citations.length})</summary>
        <ul className="mt-2 space-y-2 pl-4">
          {citations.map((c, i) => (
            <li key={`${c.source_type}-${c.source_id}-${i}`} className="border-l-2 border-border pl-3">
              <div className="font-mono text-[11px] text-taupe">{c.source_type} · {c.source_id}</div>
              <div className="text-ink mt-0.5">{c.reference}</div>
            </li>
          ))}
        </ul>
      </details>
    </div>
  );
}
